export default __webpack_public_path__ + "static/media/process-2.aebcd5c6.svg";